import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=780cecc8&scoped=true"
import script from "./ArticleItem.vue?vue&type=script&lang=js"
export * from "./ArticleItem.vue?vue&type=script&lang=js"
import style0 from "./ArticleItem.vue?vue&type=style&index=0&id=780cecc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780cecc8",
  null
  
)

export default component.exports